import * as types from "../../../_constants/types";

export default (state = [], action) => {
    switch (action.type) {
        case types.COUNTRY_LIST_LOAD:
            return [...action.results];

        case types.RESET:
        case types.COUNTRY_LIST_RESET:
            return [];

        default:
            return state;
    }
};
